import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Layout from '@/AppMain.vue';
import store from './store';

import LoginLayout from '@/AppLogin.vue';
Vue.use(Router);
import WebsiteRoutes from './routes/websites';
import ProductsRoutes from './routes/products';
import ShippmentRoutes from './routes/shippments';
import PaymentsRoutes from './routes/payments';
import OrderRoutes from './routes/orders';
import IntegrationRoutes from './routes/integration';
import FilesRoutes from './routes/files';
import SettingsRoutes from './routes/settings';
import PagesRoutes from './routes/pages';
import NotificationsRoutes from './routes/notifications';
import CategoriesRoutes from './routes/categories';
import PromotionRoutes from './routes/promotions';
import DiscountRoutes from './routes/discounts';
import BlogRoutes from './routes/blogs';
import FAQRoutes from './routes/faqs';
import SEORoutes from './routes/seo';
import InformationRoutes from './routes/informations';
import NewsRoutes from './routes/news';
import UsersRoutes from './routes/users';
import StoresRoutes from './routes/stores';
import SmakeProduct from './routes/smake_product';
import DropProduct from './routes/drop_product';
import Support from './routes/support';
export const my_routes =
  [
    {
      path: '/',
      name: 'home',
      component: Layout,
      children: [
        {
          path: '/',
          component: () => import('@/views/Home.vue'),
          meta:{auth: true, name: 'Statistics', title: 'Statistics'}
        },
      ],
    },
    {
      path: '/login',
      redirect: '',
      component: LoginLayout,
      children:[
        {
          path:'',
          name: 'login',
          component:() => import('@/views/login/login.vue'),
          meta: { title: 'Login', icon: 'login', noCache: false, guest: true },
        }
      ]
    },
    {
      path: '/forget',
      redirect: '',
      component: LoginLayout,
      children:[
        {
          path:'',
          name: 'Forget',
          component:() => import('@/views/login/forget.vue'),
          meta: { title: 'Forget password', icon: 'login', noCache: false, guest: true },
        }
      ]
    },
    {
      path: '/register',
      redirect: '',
      component: LoginLayout,
      children:[
        {
          path:'',
          name: 'register',
          component:() => import('@/views/login/register.vue'),
          meta: { title: 'Register', icon: 'register', noCache: false, guest: true },
        }
      ]
    },
      {
          path: '/request',
          redirect: '',
          component: LoginLayout,
          children:[
              {
                  path:'',
                  name: 'request',
                  component:() => import('@/views/login/request.vue'),
                  meta: { title: 'Invitation request', icon: 'request', noCache: false, guest: true },
              }
          ]
      },
      {
      path: '/resend',
      redirect: '',
      component: LoginLayout,
      children:[
          {
              path:'',
              name: 'resend verification',
              component:() => import('@/views/login/resend.vue'),
              meta: { title: 'Resend', icon: 'resend', noCache: false, guest: true },
          }
      ]
  },
    {
      path: '/verify',
      redirect: '',
      component: Layout,
      children:[
        {
          path:'',
          name: 'verify',
          component:() => import('@/views/login/verify.vue'),
          meta: {title: 'Verify'}
        }
      ],
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/user',
      name: 'user',
      component: Layout,
      children:[{
        path: 'edit',
        name: 'edit',
        component: () => import('@/views/account/edit'),
        meta: {title: 'Edit user', auth: true, name: 'Edit account'}
      },
          {
              path: 'taxes',
              name: 'taxes',
              component: () => import('@/views/account/taxes'),
              meta: {title: 'Manage taxes', auth: true, name: 'Manage taxes'}
          }
      ]
    },
    {
      path: '/emails',
      name: 'Emails',
      component: Layout,
      children:[{
        path: '/emails',
        name: 'Emails',
        component: () => import('@/views/emails/browse'),
        meta: {title: 'Edit emails', auth: true}
      }
      ]
    },
    {
      path: '/wishlist',
      name: 'wishlist',
      component: Layout,
      children:[{
        path: '',
        component: () => import('@/views/account/wishlist'),
        meta: {title: 'Lista życzeń', auth: true}
      }
      ]
    },
      FilesRoutes,
      OrderRoutes,
      WebsiteRoutes,
      ProductsRoutes,
      ShippmentRoutes,
      PaymentsRoutes,
      SettingsRoutes,
      PagesRoutes,
      NotificationsRoutes,
      CategoriesRoutes,
      PromotionRoutes,
      DiscountRoutes,
      BlogRoutes,
      FAQRoutes,
      IntegrationRoutes,
      NewsRoutes,
      SEORoutes,
      InformationRoutes,
      UsersRoutes,
      StoresRoutes,
      SmakeProduct,
      DropProduct,
      Support,
    {
      path: '*',
      name: '404',
      redirect: '404',
      component: LoginLayout,
      children:[
        {
          path:'/404',
          component:() => import('@/views/errors/404.vue'),
        }
      ]
    },

  ];
const createRouter = () => new Router({
  mode: 'history',
  base: (process.env.NODE_ENV === 'production')? '/app' : '/',
  scrollBehavior: () => ({ y: 0 }),
  routes: my_routes,
});

const router = createRouter();
router.beforeEach((from, to, next) => {
  var title = from.name;
  if(to.meta.title){
    title = from.meta.title
  }
  store.dispatch('navigation/setTitle', title);
  next();
})
export default router;
